import React from 'react'
import { getContentfulImageURL } from '../../../../lib/helpers'

const ArticleV2Image = ({image}) => {
    return (
        <div>
            <img src={getContentfulImageURL(image?.file?.url, 1000, 88)} alt="" />
            {image.description ?  <p className='caption'>{image.description}</p> : null}
            <style jsx>{`
                div {
                    margin-bottom: 2.5rem;
                }
                img {
                    width: 100%;
                    border-radius: 15px;
                }
                .caption {
                    text-align: center;
                    font-size: 12px !important;
                }
            `}</style>
        </div>
    )
}

export default ArticleV2Image